import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";

import ApiServer from "../ApiServer.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as libUrl from "../lib/url.ts";
import "./page_mealplanner.ts";
import * as Screen from "../lib/Screen.ts";
import * as mealplannerModal from "./mealplannerModal.ts";
import * as recipeModal from "./recipeModal.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";

import Icons from "../svg/Icons.ts"
import {protoExtend} from "../lib/ObjectUtil.ts"
import {recipeSyncCache,recipeCategoriesSyncCache} from "./mealplannerApi.ts";
import {familyPickOther} from "../modal/familypicker.ts";
var
  currentRecipeId;


function recipeShareMenu(this :HTMLElement){
  const
    metaId = Html.getDomMetaId(this),
    menu = [],
    othersFamily = FwDatas.getFamilies().filter(fam=>fam.metaId!==FwDatas.getFamily().metaId);
  if(othersFamily.length===0){
    menu.push({svg:Icons.ic_email,i18nkey:"actions.viaemailmessage",onclick:"mprecipeshare"})
  }else{
    var submenu = [{svg:Icons.ic_email,i18nkey:"actions.viaemailmessage",onclick:"mprecipeshare"}];
    if(othersFamily.length===1){
      submenu.push({svg:Icons.ic_share_other_circle,i18nkey:i18n.get("actions.inacircle",othersFamily[0]),onclick:"recipecopy|"+metaId+'|'+othersFamily[0].metaId})
    }else if(othersFamily.length>1){
      submenu.push({svg:Icons.ic_share_other_circle,i18nkey:"actions.inothercircle",onclick:"recipecopy|"+metaId})
    }
    menu.push({svg:Icons.ic_export,i18nkey:"actions.share",onclick:'togglemenu',submenu})
  }
  return {menu}
}

actionMenu.register({
  recipeShareMenu,
  recipeMenu(){
    const
      metaId = Html.getDomMetaId(this),
      recipe = FwDatas.get(metaId),
      menu = [];

    if(recipe.rights.canUpdate){
      menu.push({svg:Icons.ic_edit,i18nkey:"actions.edit",onclick:"recipeedit"})
    }
    var mealplannerPermission = FwDatas.getPermission('mealPlannerFlag');
    if(mealplannerPermission!=='KO_HIDE'){
      menu.push({svg:Icons.calendar.ic_plan_recipe,i18nkey:"mp.recipeplan",onclick:mealplannerPermission==='OK'?'recipeplan':'takepremium'})
    }
    menu.push({svg:Icons.ic_list,i18nkey:"mp.addtolist",onclick:'mpadditemtolist'})

    if(recipe.moodStarShortcut()){
      menu.push({svg:Icons.ic_remove_from_favorites,i18nkey:"actions.unstar",onclick:'mpunstar'})
    }else{
      menu.push({svg:Icons.ic_add_to_favorites,i18nkey:"actions.star",onclick:'mpstar'})
    }

    recipeShareMenu.apply(this).menu.forEach(sharingMenuItem=>{
      menu.push(sharingMenuItem)
    });


    menu.push({svg:Icons.ic_print,i18nkey:"actions.print",onclick:"print"})

    if(recipe.rights.canDelete){
      menu.push({svg:Icons.ic_delete,i18nkey:"actions.delete",onclick:"recipedelete",color:"var(--red)"})
    }

    return {menu}
  }
});

Html.registerDom({
  recipecancel(){
    const id = Html.getDomMetaId(this);
    if(!id){
      libLocation.goTo('recipebox.php')
      return;
    }
    var params = Object.assign(libLocation.getURLParams(),{
      mode:null,
      id,
      focus:null
    });
    libLocation.goTo(libUrl.addParams('recipebox.php',params),!Screen.isMobileView());

  },
  mprecipeshare(){
    function getLinkAndDisplay(metaId){
      ApiServer.mprecipelink(metaId,function(bean){
        import("../modal/dialog_share.mustache").then(function(TPL){
          var recipe = FwDatas.get(metaId);
          modal.openDomModal(TPL,{title: 'mp.sharerecipetitle',message:'mp.sharerecipetext',link:bean.link,pictureUrl:recipe.thumb});
        })
      })
    }

    let metaId = Html.getDomMetaId(this);
    getLinkAndDisplay(metaId);
  },

  recipeedit(metaId){
    var params = Object.assign({}, libLocation.getURLParams(),{
      mode:"edit",
      id:metaId||Html.getDomMetaId(this),
      //focus:focus?focus:undefined
    });
    libLocation.goTo(libUrl.addParams('recipebox.php',params),!Screen.isMobileView());
  },
  recipeplan(metaId=Html.getDomMetaId(this)){
    mealplannerModal.openRecipePlan(metaId)
  },
  recipeputbyid(metaId){
    ApiServer.mprecipeputbyid(metaId,function(r){
      modal.toast({svg:Icons.recipe.ic_confirmation_toast_saved_recipe,iconStyle:'width:60px',text:i18n.getMustache('mp.recipeadded',r)})
      var params = Object.assign({}, libLocation.getURLParams(),{
        id:r.metaId
      });
      libLocation.replaceState(libUrl.addParams('recipebox.php',params));

    });
    amplify.publish("recipeNeedRefresh");
  },
  recipeadd(recipeInput,url){
    recipeInput.medias = [{pictureUrl:url}];
    displayEdit(recipeInput)
  },
  async recipedelete(){
    var metaId = Html.getDomMetaId(this);

    if(!await modal.confirmDelete("mp.deleterecipe")) return;

    currentRecipeId = undefined;
    var recipe = FwDatas.get(metaId)
    recipe.isRecipe = false;
    ApiServer.mprecipeput(recipe);

    var params = Object.assign(libLocation.getURLParams(),{
      id:null
    });
    libLocation.replaceState(libUrl.addParams('recipebox.php',params));
    amplify.publish("recipeNeedRefresh");


  },
  async recipecopy(metaId=Html.getDomMetaId(this),circleId){
    modal.closeDomModal();
    if(circleId===undefined){
      var family = await familyPickOther('actions.pickfamily')
      if(!family) return;
      circleId = family.metaId;
    }
    var recipe = recipeSyncCache.get(metaId);
    ApiServer.mprecipeput.prepare({scope:circleId})(protoExtend(recipe,{metaId:null}),recipe.medias.map(media=>media.pictureUrl),function(savedRecipe){
      modal.toast({svg:Icons.ic_done,text:'mp.recipeshared'})
    })


  }
})

function displayRecipe(recipe){
  //TODO sometimes there is no recipe after creation, find why! instead of doing nothing
  if(!recipe) return;

  import("../mealplanner/recipeDetail.mustache").then(function(TPL){
    const detailEl = document.getElementById('recipeDetail');
    if (detailEl) {
      Html.setHtml(detailEl, TPL, recipe);
      detailEl.setAttribute('data-fw-meta-id', recipe.metaId);
    }
  });

  setTimeout(function(){
    const recipeNodes = document.querySelectorAll<HTMLElement>('.mp-recipe');
    recipeNodes.forEach((node) => {
      const metaId = Html.getDomMetaId(node);
      if(metaId === currentRecipeId){
        node.classList.add("selected");
        try{
          (node as any).scrollIntoViewIfNeeded();
        }catch(e){
          node.scrollIntoView(true);
        }
      }else{
        node.classList.remove("selected");
      }
    });
  }, 10);
}
function displayEdit(recipe: any){
  import("../mealplanner/recipeAdd.mustache").then(function(TPL){
    const detailEl = document.getElementById('recipeDetail');
    if (!detailEl) return;

    Html.setHtml(detailEl, TPL, recipe || {});
    detailEl.setAttribute('data-fw-meta-id', recipe ? recipe.metaId : '');

    const fieldToFocus = libLocation.getURLParam("focus");
    const fieldToFocusName = fieldToFocus ? "recipe." + fieldToFocus : "recipe.name";
    const form = detailEl.querySelector('form') as HTMLFormElement;
    if (form) {
      const fieldElement = (form as any)[fieldToFocusName] as HTMLElement;
      if (fieldElement) {
        fieldElement.focus();
      }
    }
  });
}
async function displayMainPane(){
  const recipes = (await recipeSyncCache.need()).filter((r: any) => r.isRecipe);
  currentRecipeId = libLocation.getURLParam("id") || (recipes[0] ? recipes[0].metaId : undefined);
  const mode = (recipes.length === 0 && !currentRecipeId) ? 'add' : libLocation.getURLParam("mode");
  const name = libLocation.getURLParam("name");

  const paneMain = document.querySelector(".pane-main") as HTMLElement;
  if (paneMain) {
    if(mode || libLocation.getURLParam("id")){
      paneMain.classList.add('open');
    }else{
      paneMain.classList.remove('open');
    }
  }

  if(mode==='add'){
    displayEdit({name});
  }else if(mode==='edit' && currentRecipeId){
    displayEdit(FwDatas.get(currentRecipeId));
  }else{
    displayRecipe(FwDatas.get(currentRecipeId));
  }

}

ApiServer['ui.mprecipeput'] = function(form){

  form['recipe.cookTime'].value = (parseInt(form.cookHour.value)||0)*60+(parseInt(form.cookMin.value)||0);
  form['recipe.prepTime'].value = (parseInt(form.prepHour.value)||0)*60+(parseInt(form.prepMin.value)||0);
  form['recipe.serves'].value = parseInt(form['recipe.serves'].value)||0;

  ApiServer.mprecipeput.prepare({"recipe.recipeCategoryIdList":"$empty"})(form,function(recipe){
    amplify.publish("recipeNeedRefresh");
    setTimeout(function(){Html.trigger(null,"mpclick",[recipe.metaId])},10);
  });

}


INR.onPage(INR.URL.RECIPEBOX,function(){
  //can be accessed only by premium users
  if(FwDatas.getPermission('recipeBoxFlag')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }
  if(libLocation.getURLParam('add')){
    recipeModal.recipeaddurl(libLocation.getURLParam('add'))
    libLocation.clearParamInHistory()

  }
  INR.subscribe("mpclick",function(id){
    let url = libUrl.addParams('?',{recipeview:libLocation.getURLParam("recipeview"),id:id})
    libLocation.goTo(url,!Screen.isMobileView())
  })

  INR.subscribe("recipeRefreshed",displayMainPane)
  INR.subscribe("handleParam",displayMainPane)
  amplify.publish("recipeNeedRefresh");

});
